<!--
 * @Author: your name
 * @Date: 2020-08-03 10:00:17
 * @LastEditTime: 2020-09-22 10:38:06
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /xdap-h5/src/components/footer-tab/index.vue
-->
<template>
  <div class="footer-tab">
    <cube-tab-bar
      v-model="selectTab"
      :show-slider="false"
      :inline="true"
      @click="clickHandler">
      <cube-tab v-for="(item) in tabs" :key="item.label" :class="selectTab === item.label ? 'active' : ''" :label="item.label">
        <div slot="icon" class="footer-tab--icon">
          <div v-if="getSignText(item)" class="footer-tab--sign">
          <!-- <span class="sign-text">{{ getSignText(item) }}</span> -->
          </div>
          <x-svg-icon v-if="selectTab === item.label" slot="icon" :name="item.icon + '-active'"></x-svg-icon>
          <x-svg-icon v-else slot="icon" :name="item.icon"></x-svg-icon>
        </div>
        {{ item.label }}
      </cube-tab>
    </cube-tab-bar>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import {
  SET_TODO_NUMBER
} from '@/store/tenant.store.js'
import {
  SET_MESSAGE_NUMBER
} from '@/store/auth.store.js'
import apis from '@/api'

export default {
  name: 'FooterTab',
  data() {
    return {
      selectTab: '工作台',
      tabs: [{
        label: '工作台',
        icon: 'workbench',
        code: 'workbench'
      }, {
        label: '待办',
        icon: 'todo',
        code: 'todo-center'
      }, {
        label: '消息',
        icon: 'message-center',
        code: 'message-center'
      }, {
        label: '我的',
        icon: 'mine',
        code: 'personal-center'
      }],
      timer: null
    }
  },
  computed: {
    ...mapState({
      currentOrg: state => state.tenantModule.currentOrg,
      todoNumber: state => state.tenantModule.todoNumber,
      messageNumber: state => state.authModule.messageNumber
    })
  },
  watch: {
    '$route.name': {
      handler(newVal) {
        let tab
        if (newVal === 'app-message') {
          tab = this.tabs.find(item => item.code === 'message-center')
        } else {
          tab = this.tabs.find(item => item.code === newVal)
        }
        if (tab) {
          this.selectTab = tab.label
        }
      },
      immediate: true
    }
  },
  created() {
    this.init()
  },
  methods: {
    ...mapMutations('tenantModule', {
      setTodoNumber: SET_TODO_NUMBER
    }),
    ...mapMutations('authModule', {
      setMessageNumber: SET_MESSAGE_NUMBER
    }),
    getSignText(tab) {
      if (tab.code === 'todo-center') {
        return this.todoNumber
      } else if (tab.code === 'message-center') {
        return this.messageNumber
      }
    },
    clickHandler(label) {
      this.selectTab = label
      const code = this.tabs.filter(item => item.label === label)[0].code
      this.$router.push({ name: code, params: { orgId: this.currentOrg.id } })
    },
    init() {
      this.getMessageCount()
      this.getTodoCount()
      this.initTimer()
    },
    initTimer() {
      this.timer = setInterval(() => {
        this.getMessageCount()
        this.getTodoCount()
      }, 60 * 1000)
      this.$once('hook:beforeDestroy', () => {
        clearInterval(this.timer)
      })
    },
    getMessageCount() {
      const request = { ...apis.WORKBENCH.GET_MESSAGE_COUNT }
      this.$request(request)
        .asyncThen(
          (resp) => {
            this.setMessageNumber(resp.data.newMsgNum)
          },
          (error) => {
            console.error(error)
          }
        )
        .asyncErrorCatch((error) => {
          // 网络请求非业务报错
          console.error(error)
        })
    },
    getTodoCount() {
      const request = { ...apis.WORKBENCH.QUERY_TODO_COUNT }
      this.$request(request)
        .asyncThen(
          (resp) => {
            this.setTodoNumber(resp.data.todoCount)
          },
          (error) => {
            console.error(error)
          }
        )
        .asyncErrorCatch((error) => {
          // 网络请求非业务报错
          console.error(error)
        })
    }
  }
}
</script>

<style lang="scss">
.footer-tab {
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
  height: 3.428rem;
  border-top: 1PX solid $--app-split-line-color;
  padding: 0 1.286rem;
  box-sizing: border-box;
  background-color: $--app-box-bgColor;
  z-index: 5;

  .cube-tab-bar {
    padding: 0.357rem 0;
    .cube-tab {
      flex-direction: column;
      align-items: center;
      padding: 0;
      font-size: 0.71rem;
      color: $--app-notice-color;
    }
  }
  .footer-tab--icon {
    position: relative;
    .footer-tab--sign {
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: center;
      top: 0;
      right: 0;
      background-color: $--app-danger-color;
      height: .5rem;
      width: .5rem;
      border-radius: 50%;
      .sign-text {
        color: $--app-white-font-color;
        font-size: $--app-base-font-size;
        transform: scale(0.83);
      }
    }
  }
  .active {
    color: $--app-primary-color !important;
  }
}
</style>
